import {observable, action, autorun} from 'mobx';
import CLIENT from './Client';
import UI from './UI';

let CONTENT = observable({
  defaultPageTitle: 'Scarlet Shillingford',
  holding: null,
  selectedProjects: [],
  projects: [],
  currentProject: null,
  currentProjectImages: [],
  location: null,
  aboutCopy: null,
  copyright: null
})

// --------------------------------
// /:homepage or /info

CONTENT.fetchHomepage = action(function () {

  if (!CONTENT.selectedProjects || !CONTENT.aboutCopy) {

    UI.updateLoading(true, 'fetch home')

    CLIENT
      .getEntries({
        'content_type': 'homepage',
        'sys.id': '1heXStav66G4EkwOgqYW2S',
        resolveLinks: true,
        include: 10
      }).then((response) => {
        const fields = response.items[0].fields
        CONTENT.selectedProjects = fields.selectedProjects
        CONTENT.aboutCopy = fields.aboutCopy
        CONTENT.defaultPageTitle = fields.seoTitle
        CONTENT.copyright = fields.aboutCopyright
        UI.updateLoading(false, 'fetch home')
      })
  }
})

// --------------------------------
// /projects

CONTENT.fetchAllProjects = action(function () {

  if (CONTENT.projects.length < 1) {

    UI.updateLoading(true, 'fetch projects')

    CLIENT
      .getEntries({
        'content_type': 'project',
        'order': '-fields.projectDate',
        'fields.private[ne]': true,
        resolveLinks: true,
        include: 10
      }).then((response) => {
        CONTENT.projects = response.items
        UI.updateLoading(false, 'fetch projects')
      })
  }
})

// --------------------------------
// /project/:slug

CONTENT.fetchProjectBySlug = action(function (slug) {

  UI.updateLoading(true, 'fetch project by slug')

  CONTENT.currentProject = null
  CONTENT.currentProjectImages = []

  CLIENT
    .getEntries({
      'content_type': 'project',
      'fields.slug': slug,
      resolveLinks: true,
      include: 1
    }).then((response) => {
      UI.updateLoading(false, 'fetch project by slug')
      CONTENT.currentProject = response.items[0].fields
      filterImages(response.items[0].fields.slides)
    })

})

autorun(() => {

  if (CONTENT.currentProject) {
    document.title = CONTENT.currentProject.seoTitle || CONTENT.defaultPageTitle
  }
})

const filterImages = (slides) => {
  let images = []
  slides.forEach(({fields: slide}) => {
    if (slide.coverImage) {
      images.push({
        image: slide.coverImage,
        caption: slide.caption
      })
    }
    if (slide.firstImage) {
      images.push({
        image: slide.firstImage,
        caption: slide.caption
      })
    }
    if (slide.secondImage) {
      images.push({
        image: slide.secondImage,
        caption: slide.caption
      })
    }
    if (slide.vimeo) {
      images.push({
        vimeo: slide.vimeo,
        caption: slide.caption
      })
    }
    if (slide.video) {
      images.push({
        video: slide.video,
        videoThumbnail: slide.videoThumbnail,
        caption: slide.caption
      })
    }
    if (
      slide.caption
      && !slide.coverImage
      && !slide.first
      && !slide.secondImage
      && !slide.vimeo
      && !slide.video
    ) {
      images.push({
        caption: slide.caption
      })
    }
  })
  CONTENT.currentProjectImages = images
}

export default CONTENT



// WEBPACK FOOTER //
// ./app/javascript/packs/stores/Content.js